import * as React from "react";
import { Button, Popconfirm, message } from "antd";
// import { Button } from "antd";
// 二次确认按钮
// import ButtonSecondary from "widget/buttonSecondary";
// 订单相关的枚举值
import { EOrderPayStatusSecond } from "utils/enum/orderListFormEnum";

const buttonStyle = {
  color: "#2b9fbd",
  backgroundColor: "#fff",
  borderColor: "#2b9fbd"
};

// 订单列表中的交易状态列
// orderPayStatus:交易状态id值 shipments：发货方法
const showShipmentsBtn = (
  orderPayStatus,
  shipments,
  record,
  refresh,
  containerBody
) => {
  const _refresh = () => {
    console.log("延迟1.5s执行");
    refresh();
    // setTimeout(() => {
    //   refresh();
    // }, 1500);
  };

  const getContainer = () => {
    if (containerBody) {
      return document.querySelector(containerBody) || document.body;
    } else {
      return document.body;
    }
  };

  const cb = callback => {
    shipments(record.id, callback.callback);
  };

  const submit = () => {
    cb({
      callback: data => {
        if (data && data.error) {
          message.error(data.res.msg);
        } else {
          message.success("发货成功");
          // 刷新列表
          _refresh();
        }
      }
    });
  };
  //   <Button type="primary" onClick={cb}>
  //   发货
  // </Button>
  if (Number(orderPayStatus) === Number(EOrderPayStatusSecond.maijiayifukuan)) {
    return (
      <Popconfirm
        placement="top"
        title={"确认要发货吗？"}
        overlayClassName="order-popconfirm"
        getPopupContainer={getContainer}
        overlayStyle={{ minWidth: 250, fontSize: 14 }}
        onConfirm={submit}
        okText="确定"
        cancelText="取消"
      >
        <Button type="primary" style={buttonStyle} size={"small"}>
          发货
        </Button>
      </Popconfirm>
      // <ButtonSecondary
      //   buttonText="发货"
      //   modalTitle="发货"
      //   buttonStyle={buttonStyle}
      //   buttonSize="small"
      //   ids={[record.id]}
      //   modalText={<span>确认要发货吗？</span>}
      //   warningText="请选择订单"
      //   successText="发货成功"
      //   submit={cb}
      //   cb={_refresh}
      // />
    );
  }
  return [];
};

// shipments:发货
export default (shipments, containerBody, refresh) => {
  return {
    render: (text, record) => {
      const renderBtn = () => {
        return showShipmentsBtn(
          record.orderPayStatus,
          shipments,
          record,
          refresh,
          containerBody
        );
      };
      // 把状态里面的@都替换成</br>
      var result = record.orderPayStatusStr.replace(/@/g, "</br>");
      return (
        <div style={{ paddingTop: 4, paddingBottom: 4 }}>
          <div dangerouslySetInnerHTML={{ __html: result }} />
          {renderBtn()}
        </div>
      );
    }
  };
};
